<template>
  <div class="container pb30">
    <div class="color-gray66 pt20 pl30 tl fs20 fwbold">分析详情</div>

    <div v-if="detailList.length > 0" class="content mt20">
      <!-- 遍历展示所有记录 -->
      <div v-for="(item, idx) in detailList" :key="idx" class="detail-item">
        <!-- 基础信息 -->
        <div class="listBox tl">
          <div class="fs18 fwbold color-gray66">{{ item.name }}</div>
          <div class="mt10 fs14 color-gray99" v-if="item.time">{{ item.time }}</div>
          <div class="mt10 fs14 color-gray66">
            {{ item.prompt }}
          </div>
        </div>

        <!-- 图片展示（仅第一条记录展示） -->
        <div v-if="idx === 0 && item.images && item.images.length > 0" class="listBox tl">
          <div class="fs18 fwbold color-gray66 mb10"><i class="iconfont icon-aixin"/> 截图</div>
          <div class="image-list">
            <img
              v-for="(img, imgIdx) in getDisplayImages(item.images)"
              :key="imgIdx"
              :src="img"
              class="thumb-img"
              @click="previewImage(item.images, imgIdx)"
              alt=""
            />
          </div>
        </div>

        <!-- 分析结果文本 -->
        <div v-if="item.text" class="listBox tl">
          <div class="fs18 fwbold color-gray66 mb10"><i class="iconfont icon-aixin"/> 分析结果</div>
          <div class="markdown-body" v-html="renderMarkdown(item.text)"></div>
        </div>
      </div>

      <!-- 重新提问 -->
      <div class="listBox tl">
        <div class="fs18 fwbold color-gray66 mb10"><i class="iconfont icon-aixin"/> 继续追问</div>
        <div v-if="detailList.length >= 5" style="color:#f56c6c;font-size:14px;margin-bottom:10px">
          追问次数已达上限（最多5次），无法继续提问
        </div>
        <template v-else>
          <van-field
            v-model="newPrompt"
            type="textarea"
            placeholder="请输入新的问题，例如：她现在对我的好感度有多少？"
            rows="3"
            autosize
          />
          <div class="row-center" style="margin-top: 15px">
            <van-button :loading="loading" loading-text="请求中..." class="button1Style" block type="info" @click="onSubmitPrompt">
              提交追问
            </van-button>
          </div>
        </template>
      </div>

      <div style="text-align:center;color:#444;margin-top:25px">
        <img src="../assets/qrcode.jpg" style="width:30%" alt="">
        <div style="font-size:14px;padding-top:15px">想了解更多性格分析，长按二维码关注：喵星君大大</div>
      </div>
    </div>

    <div v-else-if="loading" class="empty-tip tc color-gray99">
      加载中...
    </div>
    <div v-else class="empty-tip tc color-gray99">
      暂无数据
    </div>
  </div>
</template>
<script>
import { Toast, ImagePreview } from 'vant'
import { postAction } from '@/api/manage'

export default {
  name: 'ChatDetail',
  data() {
    return {
      detailList: [],
      newPrompt: '',
      loading: false,
      pay: '1',
    }
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {}
    },
    openid() {
      return this.userinfoLove.jsopenid
    },
    unionid() {
      return this.userinfoLove.unionid
    },
    code() {
      return this.$route.query.code ? this.$route.query.code : ''
    },
    routeName() {
      return this.$route.query.name || ''
    },
    routeSessionId() {
      return this.$route.query.session_id || ''
    },
    routeIndex() {
      return this.$route.query.index !== undefined ? Number(this.$route.query.index) : 0
    },
  },
  mounted() {
    // 本地调试：自动注入 mock 用户数据
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      this.$store.commit('setUserInfoLove', {
        unionid: 'oni4R6b8pwMrPWp0DoctYi4-Wx4M',
        jsopenid: 'mock_openid_67890',
        nickname: '测试用户',
        image: ''
      })
      this.getDetail()
      return
    }
    if (!this.unionid) {
      if (!this.code) {
        var url = encodeURIComponent(window.location.protocol + '//' + window.location.hostname + '/chatDetail')
        var query = ''
        if (this.routeName) query += '&name=' + encodeURIComponent(this.routeName)
        if (this.routeSessionId) query += '&session_id=' + encodeURIComponent(this.routeSessionId)
        if (query) url += '?' + query.substring(1)
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        this.getJsLogin()
      }
    } else {
      this.getDetail()
    }
  },
  methods: {
    getJsLogin() {
      const url = '/xcxlove/double/jslogin'
      postAction(url, { code: this.code }).then(res => {
        if (res.data.code == 200 || res.data.code == 400) {
          this.userInfo = res.data.msg
          this.$store.commit('setUserInfoLove', this.userInfo)
          this.getDetail()
        }
      })
    },
    getDetail() {
      this.loading = true
      const url = '/chat/detail'
      const params = {
        unionid: this.unionid,
        pay: this.pay,
        name: this.routeName,
      }
      postAction(url, params).then(res => {
        if (res.data.code == 200) {
          const msg = res.data.msg
          if (Array.isArray(msg) && msg.length > 0) {
            // 保存整个列表，用于展示所有记录
            this.detailList = msg
          } else {
            this.detailList = []
          }
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取显示的图片URL列表
    getDisplayImages(images) {
      if (!images) return []
      return images.map(img => this.getFullUrl(img))
    },
    previewImage(images, index) {
      const displayImages = this.getDisplayImages(images)
      ImagePreview({
        images: displayImages,
        startPosition: index,
        closeable: true,
      })
    },
    onSubmitPrompt() {
      console.log('onSubmitPrompt called')
      console.log('detailList length:', this.detailList.length)
      console.log('newPrompt:', this.newPrompt)
      
      if (this.detailList.length >= 5) {
        Toast.fail('追问次数已达上限（最多5次）')
        return
      }
      if (!this.newPrompt) {
        Toast.fail('请输入问题')
        return
      }
      this.loading = true
      const url = '/chat/analyze'
      // 使用第一条记录的图片和session_id
      const firstItem = this.detailList[0] || {}
      const imageList = (firstItem.images || []).map(img => this.getFileName(img))
      postAction(url, {
        unionid: this.unionid,
        pay: '1',
        name: firstItem.name || this.routeName,
        prompt: this.newPrompt,
        image_list: imageList,
        session_id: firstItem.session_id || this.routeSessionId,
      }).then(res => {
        if (res.data.code == 200) {
          Toast.success(res.data.msg || '提交成功')
          this.$router.push({ path: '/chatList' })
        } else {
          Toast.fail(res.data.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 从URL或路径中提取文件名
    getFileName(url) {
      if (!url) return ''
      return url.substring(url.lastIndexOf('/') + 1)
    },
    // 文件名拼接完整访问URL，已是完整URL则原样返回
    getFullUrl(img) {
      if (!img) return ''
      if (img.indexOf('http') === 0 || img.indexOf('//') === 0) return img
      return 'http://www.miaoxingjundd.com/chat/' + img
    },
    // 简易 markdown 渲染
    renderMarkdown(text) {
      if (!text) return ''
      // 转义 HTML 特殊字符
      let html = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      // 表格处理 | col | col |
      const lines = html.split('\n')
      let result = []
      let inTable = false
      let tableHtml = ''
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim()
        // 表格行
        if (line.startsWith('|') && line.endsWith('|')) {
          const cells = line.slice(1, -1).split('|').map(c => c.trim())
          // 分隔行 |---|---|
          if (cells.every(c => /^-+$/.test(c))) {
            continue
          }
          if (!inTable) {
            tableHtml = '<table class="md-table">'
            inTable = true
          }
          const tag = (tableHtml.indexOf('<thead') === -1) ? 'th' : 'td'
          if (tag === 'th') {
            tableHtml += '<thead><tr>'
            cells.forEach(c => { tableHtml += `<th>${c}</th>` })
            tableHtml += '</tr></thead><tbody>'
          } else {
            tableHtml += '<tr>'
            cells.forEach(c => { tableHtml += `<td>${c}</td>` })
            tableHtml += '</tr>'
          }
          continue
        } else if (inTable) {
          tableHtml += '</tbody></table>'
          result.push(tableHtml)
          tableHtml = ''
          inTable = false
        }
        result.push(line)
      }
      if (inTable) {
        tableHtml += '</tbody></table>'
        result.push(tableHtml)
      }

      html = result.join('\n')

      // 标题
      html = html.replace(/^### (.+)$/gm, '<h4 class="md-h4">$1</h4>')
      html = html.replace(/^## (.+)$/gm, '<h3 class="md-h3">$1</h3>')
      html = html.replace(/^# (.+)$/gm, '<h3 class="md-h3">$1</h3>')
      // 加粗
      html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      // 列表项
      html = html.replace(/^- (.+)$/gm, '<div class="md-li">• $1</div>')
      // 换行
      html = html.replace(/\n/g, '<br/>')
      // 清理标题后的多余换行
      html = html.replace(/<\/h3><br\/>/g, '</h3>')
      html = html.replace(/<\/h4><br\/>/g, '</h4>')
      html = html.replace(/<br\/><h/g, '<h')
      return html
    },
  }
}
</script>
<style scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background-image: linear-gradient(rgb(242, 197, 204), rgb(255, 255, 255));
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.listBox {
  width: 75%;
  margin: 16px auto;
  padding: 20px 16px;
  border-radius: 0px 20px 20px 20px;
  box-shadow: 0 10px 6px -6px #777;
  background: rgb(252, 252, 252);
}
.image-list {
  display: flex;
  flex-wrap: wrap;
}
.thumb-img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 4px;
  border-radius: 6px;
  cursor: pointer;
}
.button1Style {
  background: rgb(255, 174, 191);
  border: 1px solid rgb(242, 197, 204);
  font-size: 18px;
  width: 150px;
  border-radius: 6px;
}
.empty-tip {
  padding: 80px 0;
  font-size: 16px;
}
::v-deep .van-cell {
  background: rgb(233, 230, 230);
  border-radius: 10px;
}
::v-deep .van-field__label {
  color: #333;
}
.markdown-body {
  color: #444;
  font-size: 14px;
  line-height: 24px;
  word-break: break-all;
}
::v-deep .markdown-body .md-h3 {
  font-size: 17px;
  font-weight: bold;
  color: #333;
  margin: 10px 0 6px 0;
}
::v-deep .markdown-body .md-h4 {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin: 8px 0 4px 0;
}
::v-deep .markdown-body .md-li {
  margin-left: 6px;
}
::v-deep .markdown-body .md-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 13px;
}
::v-deep .markdown-body .md-table th {
  border: 1px solid #ddd;
  background: rgb(245, 245, 245);
  padding: 6px;
}
::v-deep .markdown-body .md-table td {
  border: 1px solid #ddd;
  padding: 6px;
}
</style>
